import * as React from "react";
import { Map } from "immutable";
import { $, merge } from "glamor";

interface IProps {
    value: string;
    node: any;
    column: any;
    api: any;
    context: { getFocusOnCellMap?: () => Map<string, any> };
}

export const focusDecorator = (Component) => {
    return class FocusDecorator extends React.PureComponent<IProps, any> {
        private styles = merge(
            {
                height: "100%",
            },
            $(" .focusOn", {
                position: "absolute",
                top: "-12px",
                right: "0px",
                zIndex: 2,
                color: "white",
                lineHeight: "12px",
                fontWeight: "bold",
                fontSize: "8px",
                padding: "0 2px",
                opacity: 0,
                transition: "all .2s ease-out",
            }),
            $(":hover .focusOn", {
                opacity: 0.9,
                top: "0px",
            })
        );
        render() {
            const { node, column, api, context } = this.props;
            const { getFocusOnCellMap } = context;
            let name = null;
            let color = null;
            const focusOn = getFocusOnCellMap && getFocusOnCellMap().get(`${node.id}.${column.colId}`);
            if (focusOn) {
                const myFocused = api.getFocusedCell();
                const myFocusedRowIndex = myFocused && api.getRenderedNodes()[myFocused.rowIndex];
                if (!myFocused || myFocusedRowIndex !== node.rowIndex || myFocused.column.colId !== column.colId) {
                    name = focusOn.getIn(["sessions", 0, "identity_info", "display_name"]);
                    color = focusOn.get("color");
                }
            }
            return (
                <div className="focusDecorator" {...this.styles}>
                    {name && color && (
                        <div className="focusOn" style={{ backgroundColor: color }}>
                            {name}
                        </div>
                    )}
                    <Component {...this.props} />
                </div>
            );
        }
        refresh() {
            return false;
        }
    };
};
